import React, { ReactElement, ReactNode } from 'react'
import { Flex, ThemeUIStyleObject } from 'theme-ui'

interface AnimatedSquareProps {
  children?: ReactNode
  sx?: ThemeUIStyleObject
}

const AnimatedSquare = ({ children, sx }: AnimatedSquareProps): ReactElement => {
  return (
    <Flex
      className="ios-scrolling-glitches-fix"
      sx={{
        height: ['35.8rem', '64.5rem'],
        width: ['35.8rem', '64.5rem'],
        fill: 'smokyBlack',
        border: '1px solid',
        zIndex: 'zIndex1',
        borderColor: 'blueYonder20',
        alignSelf: 'center',
        alignItems: 'center',
        justifyContent: 'center',
        background:
          'linear-gradient(0deg, #01091D, #01091D), linear-gradient(270deg, rgba(179, 163, 255, 0.3) 0%, rgba(179, 163, 255, 0.3) 100%)',
        filter: 'drop-shadow(0px 0px 120px rgba(39, 97, 228, 0.20))',
        borderRadius: '1rem',
        flexShrink: 0,
        boxShadow: '0px 0px 120px 0px #2761E433',
        WebkitTransform: 'translateZ(0)',
        '@media screen and (max-width: 380px)': {
          height: '25rem',
          width: '25rem',
        },
        '@media screen and (min-width: 524px) and (max-width: 768px)': {
          height: '45.8rem',
          width: '45.8rem',
        },
        '@media screen and (min-width: 768px) and (max-width: 980px)': {
          width: '36rem',
          height: '36rem',
        },
        '@media screen and (min-width: 981px) and (max-width: 1120px)': {
          width: '48rem',
          height: '48rem',
        },
        '@media screen and (min-width: 1121px) and (max-width: 1500px)': {
          width: '53rem',
          height: '53rem',
        },
        ...sx,
      }}
    >
      {children}
    </Flex>
  )
}

export default AnimatedSquare
